import React from 'react'
import { Link } from 'react-router-dom'
import { Typography, Tabs, Row, Col, Form, Input, Switch, DatePicker, TimePicker, Icon, Button, Modal, Checkbox, Select } from 'antd'
import { withApollo } from 'react-apollo'
import Container from '../../../../components/user/Container'
//////////////////////addmodalINTERNAL_SERVER_ERROR
import ModalErrors from '../../../../components/user/ModalErrors'

const { Option } = Select;
const { Search } = Input;

class CalendarForm extends React.Component {

    state = {
        idMeeting: null,
        statusAccept: "approve",
        showModalAcceptInvite: false,
        textModalSuccess: '',
        showModalSuccess: false,
        showModalCancleInvite: false,
        textModalCancle: '',
        showModalCancle: false,
        showModalChangeUser: false,
        listInviteInternal: [{
            id: "4",
            name: "นาง นวมล  ภัททกิจโภคิน์",
            status: "wait",
        }, {
            id: "5",
            name: "นาง ปัญญ์ธิบดิ์  ปรีชาเตชะสกุล",
            status: "wait",
        }, {
            id: "6",
            name: "นาย สรสงษ์ งามเปี่ยม",
            status: "wait",
        }, {
            id: "7",
            name: "นาง ปัญญ์ธิบดิ์  ปรีชาเตชะสกุล",
            status: "wait",
        }, {
            id: "8",
            name: "นาง ปัญญ์ธิบดิ์  ปรีชาเตชะสกุล",
            status: "wait",
        }, {
            id: "9",
            name: "นาง ปัญญ์ธิบดิ์  ปรีชาเตชะสกุล",
            status: "wait",
        }, {
            id: "10",
            name: "นาง ปัญญ์ธิบดิ์  ปรีชาเตชะสกุล",
            status: "wait",
        }, {
            id: "11",
            name: "นาง ปัญญ์ธิบดิ์  ปรีชาเตชะสกุล",
            status: "wait",
        }, {
            id: "12",
            name: "นาง ปัญญ์ธิบดิ์  ปรีชาเตชะสกุล",
            status: "wait",
        }, {
            id: "13",
            name: "นาง ปัญญ์ธิบดิ์  ปรีชาเตชะสกุล",
            status: "wait",
        }, {
            id: "14",
            name: "นาง ปัญญ์ธิบดิ์  ปรีชาเตชะสกุล",
            status: "wait",
        }, {
            id: "15",
            name: "นาง ปัญญ์ธิบดิ์  ปรีชาเตชะสกุล",
            status: "wait",
        }, {
            id: "16",
            name: "นาง ปัญญ์ธิบดิ์  ปรีชาเตชะสกุล",
            status: "wait",
        }, {
            id: "17",
            name: "นาง ปัญญ์ธิบดิ์  ปรีชาเตชะสกุล",
            status: "wait",
        }, {
            id: "18",
            name: "นาง ปัญญ์ธิบดิ์  ปรีชาเตชะสกุล",
            status: "wait",
        }, {
            id: "19",
            name: "นาง ปัญญ์ธิบดิ์  ปรีชาเตชะสกุล",
            status: "wait",
        }, {
            id: "20",
            name: "นาง ปัญญ์ธิบดิ์  ปรีชาเตชะสกุล",
            status: "wait",
        }, {
            id: "21",
            name: "นาง ปัญญ์ธิบดิ์  ปรีชาเตชะสกุล",
            status: "wait",
        }, {
            id: "22",
            name: "นาง ปัญญ์ธิบดิ์  ปรีชาเตชะสกุล",
            status: "wait",
        }, {
            id: "23",
            name: "นาง ปัญญ์ธิบดิ์  ปรีชาเตชะสกุล",
            status: "wait",
        }, {
            id: "24",
            name: "นาง ปัญญ์ธิบดิ์  ปรีชาเตชะสกุล",
            status: "wait",
        }
        ],
    }

    componentDidMount = async () => {
        if (this.props.location.search) {
            let param = this.props.location.search.replace("?", "").split(",");
            param.forEach(async element => {
                let temp = element.split("=")
                if (temp[0] == "id") {
                    await this.setState({
                        idMeeting: temp[1]
                    })
                }
                else if (temp[0] == "status") {
                    await this.setState({
                        statusAccept: temp[1]
                    })
                }
            });
        }
    }

    handleCancel = () => {
        this.setState({
            showModalAcceptInvite: false,
            showModalCancelInvite: false,
            showModalChangeUser: false,
        })
    }
    handleOpen = () => {
        this.setState({
            showModalAcceptInvite: true
        })
    }
    handleOkSaveAcceptInviteSuccess = () => {
        this.setState({
            textModalSuccess: 'เข้าร่วมการประชุมสำเร็จ',
            showModalAcceptInvite: false,
            showModalSuccess: true,
        })
        setTimeout(() => {
            this.setState({
                showModalSuccess: false
            })
        }, 1000);
    }

    handleCancleMeeting = () => {
        this.setState({
            showModalCancelInvite: true
        })
    }
    handleOkCancelInviteSuccess = () => {
        this.setState({
            textModalDelete: 'ปฏิเสธการประชุม',
            showModalCancelInvite: false,
            showModalConfirmDelete: true,
        })
        setTimeout(() => {
            this.setState({
                showModalConfirmDelete: false
            })
        }, 1000);
    }

    handleChangeUser = () => {
        this.setState({
            showModalChangeUser: true
        })
    }
    handleOkSaveChangeUser = () => {
        this.setState({
            textModalSuccess: 'ส่งตัวแทนเข้าร่วมการประชุมสำเร็จ',
            showModalChangeUser: false,
            showModalSuccess: true,
        })
        setTimeout(() => {
            this.setState({
                showModalSuccess: false
            })
        }, 1000);
    }
    render() {
        const { match } = this.props
        return (
            <Container match={match}>
                {/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
                {
                    this.state.showModalConfirmErrors &&
                    <ModalErrors />
                }
                {/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}

                <Modal
                    className={'meeting-management-modal'}
                    visible={this.state.showModalSuccess}
                    onCancel={this.handleCancel}
                    footer={null}
                    closable={false}
                >
                    <div className={'py-5'} style={{ textAlign: 'center', color: "#178991" }}>
                        <Icon style={{ fontSize: "70px", paddingBottom: "30px" }} type="check-circle" />
                        <p style={{ fontSize: "20px" }}>
                            {this.state.textModalSuccess}
                        </p>
                    </div>
                </Modal>
                <Modal
                    className={'meeting-management-modal'}
                    visible={this.state.showModalAcceptInvite}
                    onCancel={this.handleCancel}
                    footer={[
                        <Button key="back" className={'btn-modal-cancle'} onClick={this.handleCancel}>
                            ยกเลิก</Button>,
                        <Button key="submit" className={'btn-modal-confirm'} onClick={this.handleOkSaveAcceptInviteSuccess}>
                            ยืนยัน</Button>,
                    ]}
                    closable={false}
                >
                    <div align="center">
                        <p style={{ fontSize: "20px" }}>
                            คุณตอบรับการเข้าร่วมประชุม<br />
                            ใช่หรือไม่
                        </p>
                    </div>
                </Modal>

                <Modal
                    className={'meeting-management-modal'}
                    visible={this.state.showModalConfirmDelete}
                    onCancel={this.handleCancel}
                    footer={null}
                    closable={false}
                >
                    <div className={'py-5'} style={{ textAlign: 'center', color: "#d7222a" }}>
                        <Icon style={{ fontSize: "70px", paddingBottom: "30px" }} type="close-circle" />
                        <p style={{ fontSize: "20px" }}>
                            {this.state.textModalDelete}
                        </p>
                    </div>
                </Modal>
                <Modal
                    className={'meeting-management-modal'}
                    visible={this.state.showModalAcceptInvite}
                    onCancel={this.handleCancel}
                    footer={[
                        <Button key="back" className={'btn-modal-cancle'} onClick={this.handleCancel}>
                            ยกเลิก</Button>,
                        <Button key="submit" className={'btn-modal-confirm'} onClick={this.handleOkSaveAcceptInviteSuccess}>
                            ยืนยัน</Button>,
                    ]}
                    closable={false}
                >
                    <div align="center">
                        <p style={{ fontSize: "20px" }}>
                            คุณตอบรับการเข้าร่วมประชุม<br />
                            ใช่หรือไม่
                        </p>
                    </div>
                </Modal>


                <Modal
                    className={'meeting-management-modal'}
                    visible={this.state.showModalCancelInvite}
                    onCancel={this.handleCancel}
                    footer={[
                        <Button key="back" className={'btn-modal-cancle'} onClick={this.handleCancel}>
                            ยกเลิก</Button>,
                        <Button key="submit" className={'btn-modal-confirm'} onClick={this.handleOkCancelInviteSuccess}>
                            ยืนยัน</Button>,
                    ]}
                    closable={false}
                >
                    <div align="center">
                        <p style={{ fontSize: "20px" }}>
                            คุณปฏิเสธการเข้าร่วมประชุม
                            ใช่หรือไม่<br />
                        </p>
                    </div>
                </Modal>

                <Modal
                    className={'meeting-management-modal'}
                    visible={this.state.showModalChangeUser}
                    onCancel={this.handleCancel}
                    footer={[
                        <Button key="back" className={'btn-modal-cancle'} onClick={this.handleCancel}>
                            ยกเลิก</Button>,
                        <Button key="submit" className={'btn-modal-confirm'} onClick={this.handleOkSaveChangeUser}>
                            ยืนยัน</Button>,
                    ]}
                    closable={false}
                >
                    <Row gutter={16}>
                        <Col xs={24} className={'pb-2'}>
                            <h3>เพิ่มผู้เข้าร่วมภายใน</h3>
                            <Input placeholder="ค้นหา" onSearch={value => console.log(value)} />
                        </Col>
                        <Col xs={24}>
                            <h2>กลุ่ม</h2>
                            <Select defaultValue="no" style={{ width: '100%' }} onChange={this.ChangeGroup}>
                                <Option disabled value="no"><p style={{ color: "#d9d9d9" }}>กรุณาเลือกกลุ่ม</p></Option>
                                <Option value="กลุ่ม1">กลุ่ม1</Option>
                                <Option value="กลุ่ม2">กลุ่ม2</Option>
                                <Option value="กลุ่ม3">กลุ่ม3</Option>
                            </Select>
                        </Col>
                        <Col xs={24}>
                            <h2>หน่วยงาน</h2>
                            <Row gutter={16}>
                                <Col xs={12}>
                                    <Select defaultValue="no" style={{ width: '100%' }} onChange={this.ChangeGroup}>
                                        <Option disabled value="no"><p style={{ color: "#d9d9d9" }}>กรุณาเลือกฝ่าย</p></Option>
                                        <Option value="ฝ่าย1">ฝ่าย1</Option>
                                        <Option value="ฝ่าย2">ฝ่าย2</Option>
                                        <Option value="ฝ่าย3">ฝ่าย3</Option>
                                    </Select>
                                </Col>
                                <Col xs={12}>
                                    <Select defaultValue="no" style={{ width: '100%' }} onChange={this.ChangeGroup}>
                                        <Option disabled value="no"><p style={{ color: "#d9d9d9" }}>กรุณาเลือกแผนก</p></Option>
                                        <Option value="แผนก1">แผนก1</Option>
                                        <Option value="แผนก2">แผนก2</Option>
                                        <Option value="แผนก3">แผนก3</Option>
                                    </Select>
                                </Col>
                            </Row>
                        </Col>
                        <div style={{ height: 400, width: 450, overflow: "auto" }}>
                            {this.state.listInviteInternal.map((user, i) => {
                                return (
                                    <Col xs={24} className={'py-1'}>
                                        <Checkbox onChange={this.onCheckAddInternal} value={user.id}> <p style={{ fontSize: "14px", display: "inline" }}>{user.name}</p></Checkbox>
                                    </Col>
                                )
                            })}
                        </div>
                    </Row>
                </Modal>

                <div className="card-container meeting-management" id="form-meeting">
                    <div className="card-bg-white">
                        <Row className="pt-4 pb-3 px-3" gutter={16} type="flex">
                            <Col xs={19} >
                                <Link
                                    to={{
                                        pathname: `/meeting`,
                                    }}>
                                    <Icon type="left" className="icon-back-meeting" /><p style={{ display: "inline", color: "#4D4D4D" }}> รายละเอียดการประชุม</p>
                                </Link>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col lg={{ span: 20, offset: 2 }}>
                                <Row className="px-5 py-3 pb-5" gutter={16} type="flex" align="top">
                                    <Col xs={24}>
                                        <p className="text-header-meeting">ส่งบันทึกหลังการประชุม</p>
                                    </Col>
                                    {/* <Icon type="user" className="icon-fonttext-meeting" /> */}
                                    <Col xs={12}>
                                        <Icon type="user" className="icon-fonttext-meeting" />
                                        <p className="text-title-meeting ml-2 mb-0">ผู้เชิญประชุม</p><br />
                                        <p className="text-detail-meeting ml-2">นางสาว ธนพร สิริโสภา</p>
                                    </Col>
                                    {/* <Icon type="user" className="icon-fonttext-meeting" /> */}
                                    <Col xs={12}>
                                        <Icon type="user" className="icon-fonttext-meeting" />
                                        <p className="text-title-meeting ml-2 mb-0">ผู้อนุมัติการประชุม</p><br />
                                        {/* <Icon type="user" className="icon-fonttext-meeting-none" /> */}
                                        <p className="text-detail-meeting ml-2">นาย ไกรธนเดช  นันทเจริญสกุล</p>
                                    </Col>

                                    <Col xs={24} className="pt-3">
                                        <Icon type="menu" className="icon-fonttext-meeting" />
                                        <p className="text-title-meeting ml-2 mb-0">หัวข้อการประชุม</p><br />
                                        {/* <Icon type="menu" className="icon-fonttext-meeting-none" /> */}
                                        <p className="text-detail-meeting ml-2">รายงานการประชุมเพื่อเตรียมความพร้อมประจำปี</p>
                                    </Col>

                                    <Col xs={12} className="pt-3">
                                        <Icon type="clock-circle" className="icon-fonttext-meeting" />
                                        <p className="text-title-meeting ml-2 mb-0">กำหนดการ</p><br />
                                        {/* <Icon type="clock-circle" className="icon-fonttext-meeting-none" /> */}
                                        <p className="text-detail-meeting ml-2">21 กุมภาพันธ์ 2565 / 10:00 - 14:00 น.</p>
                                    </Col>
                                    <Col xs={12} className="pt-3">
                                        <Icon type="clock-circle" className="icon-fonttext-meeting" />
                                        <p className="text-title-meeting ml-2 mb-0" style={{ display: 'inline' }}>วันที่ออกเอกสาร</p><br />
                                        {/* <Icon type="clock-circle" className="icon-fonttext-meeting-none" style={{ display: 'inline' }} /> */}
                                        <p className="text-detail-meeting ml-2" style={{ display: 'inline' }}>18 กุมภาพันธ์ 2565</p>
                                    </Col>

                                    <Col xs={24} className="pt-3">
                                        <Icon type="environment" className="icon-fonttext-meeting" />
                                        <p className="text-title-meeting ml-2 mb-0">สถานที่จัดการประชุม</p><br />
                                        {/* <Icon type="environment" className="icon-fonttext-meeting-none" /> */}
                                        <p className="text-detail-meeting ml-2">1871 ถนนพระราม 4 แขวงปทุมวัน เขตปทุมวัน กรุงเทพฯ 10330</p>
                                    </Col>

                                    <Col xs={24} className="pt-3">
                                        <Icon type="team" className="icon-fonttext-meeting" />
                                        <p className="text-title-meeting ml-2 mb-0">รายชื่อผู้ถูกเชิญ (13)</p><br />
                                    </Col>

                                    <Col xs={12} className="pt-3">
                                        {/* <Icon type="clock-circle" className="icon-fonttext-meeting-none" /> */}
                                        <p className="text-title-meeting ml-2">ผู้เข้าร่วมภายใน (9/10)</p><br />
                                        <p className="text-detail-meeting ml-4">1. นางสาว ธนพร  สิริโสภา</p><br />
                                        <p className="text-detail-meeting ml-4">2. นางสาว ชิดชนก  จิรวราพงศ์</p><br />
                                        <p className="text-detail-meeting ml-4">3. นาง ดรัลพร  จิรอรรถธาดา</p><br />
                                        <p className="text-detail-meeting ml-4">4. นาง นวมล  ภัททกิจโภคิน์</p><br />
                                        <p className="text-detail-meeting ml-4">5. นาง ปัญญ์ธิบดิ์  ปรีชาเตชะสกุล</p><br />
                                        <a className="see-more-button">
                                            <p>ดูเพิ่มเติม</p>
                                        </a>
                                    </Col>
                                    <Col xs={12} className="pt-3">
                                        {/* <Icon type="clock-circle" className="icon-fonttext-meeting-none" /> */}
                                        <p className="text-title-meeting ml-2">ผู้เข้าร่วมภายนอก (3/3)</p><br />
                                        <p className="text-detail-meeting ml-4">1. นางสาว ปัญญ์ธิบดิ์  ปรีชาเตชะสกุล</p><br />
                                        <p className="text-detail-meeting ml-4">2. นางสาว ชมพูนุท  โฆษิตโภคินันท์</p><br />
                                        <p className="text-detail-meeting ml-4">3. นาง นวตา  วัชรสกุลกิจ</p><br />
                                    </Col>

                                    <Col xs={24} className="pt-3">
                                        <Icon type="menu" className="icon-fonttext-meeting" />
                                        <p className="text-title-meeting ml-2 mb-0">รายละเอียด</p><br />
                                        {/* <Icon type="menu" className="icon-fonttext-meeting-none" /> */}
                                        <p className="text-detail-meeting ml-2">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vitae, at amet amet vulputate auctor. Cursus lobortis est lobortis cras aliquet cum vitae. Montes, nunc duis blandit sed fringilla nulla augue vitae ipsum.</p>
                                    </Col>

                                    <Col xs={24} className="pt-3">
                                        <Icon type="menu" className="icon-fonttext-meeting" />
                                        <p className="text-title-meeting ml-2 mb-0">ลิงค์การประชุม</p><br />
                                        {/* <Icon type="menu" className="icon-fonttext-meeting-none" /> */}
                                        <p className="text-detail-meeting ml-2">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vitae, at amet amet vulputate auctor. Cursus lobortis est lobortis cras aliquet cum vitae. Montes, nunc duis blandit sed fringilla nulla augue vitae ipsum.</p>
                                    </Col>

                                    <Col xs={24} className="pt-3">
                                        <Icon type="paper-clip" className="icon-fonttext-meeting" />
                                        <p className="text-title-meeting ml-2 mb-0">ไฟล์แนบ</p><br />
                                        {/* <Icon type="menu" className="icon-fonttext-meeting-none" /> */}
                                        <a className="text-detail-meeting ml-2">ระเบียบวาระการประชุม.pdf</a><br />
                                        {/* <Icon type="menu" className="icon-fonttext-meeting-none" /> */}
                                        <a className="text-detail-meeting ml-2">เอกสารประกอบการประชุม.pdf</a><br />
                                    </Col>

                                    {this.state.statusAccept == "wait" ?
                                        <>
                                            <Col span={4} offset={8} align="end">
                                                <Button onClick={this.handleCancleMeeting} className={'button-meeting-approve mt-3 mt-lg-0'} style={{ color: "#808080", backgroundColor: "transparent" }}>
                                                    ปฏิเสธ</Button>
                                            </Col>
                                            <Col span={4} align="end">
                                                <Button className={'button-meeting-approve mt-3 mt-lg-0'} style={{ color: "#808080", backgroundColor: "transparent" }} onClick={this.handleChangeUser}>
                                                    ส่งตัวแทน</Button>
                                            </Col>
                                            <Col span={4} align="end">
                                                <Button className={'button-meeting-approve mt-3 mt-lg-0'} style={{ color: "#ffffff" }} onClick={this.handleOpen}>
                                                    ตอบรับ</Button>
                                            </Col>
                                        </>
                                        :
                                        <></>
                                    }
                                    {this.state.statusAccept == "yes" ?
                                        <>
                                            <Col span={4} offset={8} align="end">
                                            </Col>
                                            <Col span={4} align="end">
                                                <Button className={'button-meeting-approve mt-3 mt-lg-0'} style={{ color: "#808080", backgroundColor: "transparent" }} onClick={this.handleChangeUser}>
                                                    ส่งตัวแทน</Button>
                                            </Col>
                                            <Col span={4} align="end">
                                                <Button className={'button-meeting-approve mt-3 mt-lg-0'} style={{ color: "#ffffff", backgroundColor: "#D94339" }} onClick={this.handleCancleMeeting}>
                                                    ปฏิเสธ</Button>
                                            </Col>
                                        </>
                                        :
                                        <></>
                                    }
                                    {this.state.statusAccept == "no" ?
                                        <>
                                            <Col span={4} offset={8} align="end">
                                            </Col>
                                            <Col span={4} align="end">
                                                <Button className={'button-meeting-approve mt-3 mt-lg-0'} style={{ color: "#808080", backgroundColor: "transparent" }} onClick={this.handleChangeUser}>
                                                    ส่งตัวแทน</Button>
                                            </Col>
                                            <Col span={4} align="end">
                                                <Button className={'button-meeting-approve mt-3 mt-lg-0'} style={{ color: "#ffffff" }} onClick={this.handleOpen}>
                                                    ตอบรับ</Button>
                                            </Col>
                                        </>
                                        :
                                        <></>
                                    }
                                    {this.state.statusAccept == "agent" ?
                                        <>
                                            <Col span={4} offset={8} align="end">
                                            </Col>
                                            <Col span={4} align="end">
                                                <Button className={'button-meeting-approve mt-3 mt-lg-0'} style={{ color: "#ffffff", backgroundColor: "#D94339" }} onClick={this.handleCancleMeeting}>
                                                    ปฏิเสธ</Button>
                                            </Col>
                                            <Col span={4} align="end">
                                                <Button className={'button-meeting-approve mt-3 mt-lg-0'} style={{ color: "#ffffff" }} onClick={this.handleOpen}>
                                                    ตอบรับ</Button>
                                            </Col>
                                        </>
                                        :
                                        <></>
                                    }
                                </Row>
                            </Col>
                        </Row>
                    </div>
                </div>
            </Container >
        )
    }
}

CalendarForm.propTypes = {
    //
}

export default withApollo(CalendarForm)